import styled from 'styled-components';
import { theme } from 'constants/theme';
import MEDIA from '../../helpers/mediaTemplates';

export const Container = styled.form`
  position: relative;
  width: 100%;

  input:not([type="radio"]),
  textarea {
    min-width: 100%;
    border: none;
    resize: none;
    min-height: 44px;
    padding: 1.3rem;
    margin: 1rem 0;
    outline-color: ${theme.colors.base};
    border-radius: 0;
    color: ${theme.colors.base};
    font-family: ${theme.fonts.bodyFont.name}, ${theme.fonts.bodyFont.type};
    font-size: 19px;
    position: relative;
    background: white;
    width: 100%;
  }

  label {
    width: 100%;
  }

  input[type="date"]::-webkit-calendar-picker-indicator {
    opacity: 1;
    display: block;
    width: 15px;
    height: 15px;
    padding: 5px;
    border-width: thin;
    cursor: pointer;
}

  ${MEDIA.MIN_PHONE`
    .half {
      width: calc(50% - 1rem);
      display: inline-block;

      &:nth-child(2n - 1) {
        margin-right: 2rem;
      }
    }
  `}


  input,
  input::placeholder,
  textarea::placeholder {
    color: ${theme.colors.base};
  }

  textarea {
    height: 300px;
    font-family: ${theme.fonts.bodyFont.name}, ${theme.fonts.bodyFont.type};
  }

  /* .CalendarDay:hover {
    background: ${theme.colors.bg};
  }

  .CalendarDay__selected_span {
    background: ${theme.colors.base};
    color: ${theme.colors.bg2};
    border: 1px solid ${theme.colors.base};
  }

  .CalendarDay__selected {
    background: ${theme.colors.base};
    color: ${theme.colors.bg2};
    border: 1px solid ${theme.colors.base};

    &:focus {
      outline: none;
    }
  }

  .CalendarDay__selected:hover {
    background: ${theme.colors.base};
    color: ${theme.colors.bg};
    outline: 1px solid ${theme.colors.bg};
  }

  .CalendarDay__hovered_span:hover,
  .CalendarDay__hovered_span {
    background: ${theme.colors.base};
    color: ${theme.colors.bg};
    border-color: ${theme.colors.base};
  }

  .DayPickerKeyboardShortcuts_show__bottomRight::before {
    border-right-color: ${theme.colors.base};
  }

  .CalendarDay__selected_span:active,
  .CalendarDay__selected_span:hover {
    background: ${theme.colors.base};
    color: ${theme.colors.bg};
  }

  .DateRangePicker {
    margin-bottom: 2rem;
    width: 100%;

    .DateRangePickerInput {
      display: flex;
      flex-wrap: nowrap;
      flex-direction: row;
      flex: 1 1 0px;
      width: 100%;
      align-items: center;
      border: none;

      .DateInput {
        flex: 1;
      }
    }

    input {
      width: 100%;
    }

    svg {
      fill: ${theme.colors.base};
    }
  }

  .DateInput_input {
    text-align: center;
    border: none;
  } */

  label {
    text-transform: uppercase;
    letter-spacing: 1px;
    font-weight: 800;
    font-size: 1rem;
    font-family: Silk, serif;
  }

  input[type="radio"] {
    margin: 0 1rem;
    cursor: pointer;
  }

  .radio-container {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    label {
      width: auto;
    }
  }

  .submit {
    background: ${theme.colors.base};
    border: none;
    padding: 2rem 6rem;
    color: ${theme.colors.bg};
    font-weight: 800;
    cursor: pointer;
    font-family: ${theme.fonts.headerFont.name}, ${theme.fonts.headerFont.type};
    text-transform: uppercase;
    letter-spacing: 2px;

    &:hover {
      background: ${theme.colors.base2};
      color: ${theme.colors.base};
    }
  }
`;
